"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeWithoutAwait = executeWithoutAwait;
/**
 * Process asynchronous functionalities in a non-blocking way.
 * Adding additional catch for every promise to log properly errors and avoid unhandled promise rejections.
 */
function executeWithoutAwait(input, logger, failureLogs) {
    const promises = Array.isArray(input) ? input : [input];
    promises.forEach((promise) => {
        promise.catch((err) => {
            logger.error({
                message: err?.message || "Unknown error while executing promise without await",
                stack: err?.stack,
                err,
                ...failureLogs,
            });
        });
    });
}
//# sourceMappingURL=execute-without-await.js.map